var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMouseClick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd",
    viewBox: "0 0 350 512.41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M332.21 242.76h-121.9v-33.87c9.96-3.66 17.16-13.27 17.16-24.48v-37.72c0-11.21-7.18-20.83-17.16-24.49V72.94h8.79c31.1 0 59.38 12.73 79.88 33.23 20.5 20.5 33.23 48.78 33.23 79.88v56.71zm-139.7-120.55c-9.99 3.67-17.16 13.31-17.16 24.48v37.72c0 11.16 7.2 20.8 17.16 24.48v33.87H71.37l-.76.04v-56.75c0-31.1 12.73-59.38 33.24-79.88 20.5-20.5 48.78-33.23 79.87-33.23h8.79v49.27zM78.2 57.13 42.13 21.05c-4.74-4.73-12.42-4.73-17.15 0-4.74 4.74-4.73 12.42 0 17.16l35.7 35.69c5.18-6.23 11.07-11.86 17.52-16.77zm52.84-21.18L116.96 6.3c-3.2-5.86-10.55-8.02-16.4-4.82-5.87 3.2-8.03 10.55-4.83 16.41l12.18 23.28 23.13-5.22zm-93.85 89.42a106.14 106.14 0 0 1 6.4-22.97l-25.7-13.86c-5.86-3.21-13.21-1.04-16.41 4.82-3.2 5.86-1.04 13.21 4.82 16.4l30.89 15.61zm33.42 135.15.76.04h260.84v120.95c0 31.1-12.73 59.38-33.23 79.88-20.5 20.5-48.78 33.23-79.88 33.23h-35.38c-31.09 0-59.37-12.73-79.87-33.23-20.51-20.5-33.24-48.78-33.24-79.88V260.52zm113.11 251.89h35.38c36 0 68.74-14.72 92.46-38.44S350 417.52 350 381.51V186.05c0-36.01-14.72-68.74-38.44-92.46S255.1 55.15 219.1 55.15h-35.38c-36.01 0-68.74 14.73-92.45 38.44-23.72 23.72-38.45 56.45-38.45 92.46v195.46c0 36.01 14.73 68.74 38.45 92.46 23.71 23.72 56.44 38.44 92.45 38.44z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF185",
    d: "M192.51 72.94v49.27c-9.99 3.67-17.16 13.31-17.16 24.48v37.73c0 11.16 7.2 20.79 17.16 24.46v33.88H71.37l-.76.04v-56.75c0-31.1 12.73-59.38 33.24-79.88 20.5-20.5 48.78-33.23 79.87-33.23h8.79z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMouseClick);
export default __webpack_public_path__ + "static/media/mouse-click.8a0cd4b3241f39e8f35e797451b9bb73.svg";
export { ForwardRef as ReactComponent };